import { Col, Form, Row } from "react-bootstrap";
import { Block } from "../../../hoc/Block";
import { InputField } from "../../../components/controls/InputField/InputField";
import React, {useEffect, useState} from "react";

export const AssessmentSettings = (props) => {
  const [isQuantitativeVisible, setIsQuantitativeVisible] = useState(false);
  // const [qualOnly, setQualOnly] = useState(props.qualOnly);

  useEffect(() => {
    setIsQuantitativeVisible((!props.qualOnly && props.showKPIs) ? true : false);
  }, [props])

  const handleChange = function(e) {
    let value = e.target.value === 'true';
    // console.log("e value modified", value);
    setIsQuantitativeVisible(!value);
    props.onChangeQualitativeEval(e);
  }
  // console.log("!props.isEditChecklist || qualOnly ", !props.isEditChecklist || props.qualOnly);
  // console.log("props.isEditChecklist && !qualOnly ", props.isEditChecklist && !props.qualOnly)
  // console.log("qualOnlyValue ", props.qualOnly);
  return (
    <div>
        <p className="text-start fw-bold mt-3 mb-0">
          Assessment Settings
        </p>
        <div className="hr"></div>
        <Block disabled={props.disabled}>
          <Row className="my-1">
            <Col sm={5} className="text-start">
              <label className="fst-italic">Qualitative Evaluation only?</label>
            </Col>
            <Col className="ps-1 d-flex justify-content-start">
              <Form.Check
                inline
                label="Yes"
                type="radio"
                className="fw-bold text-start"
                name="qualitative-evaluation"
                id="yes"
                value={true}
                checked={props.qualOnly}
                onChange={handleChange}
              />
              <Form.Check
                inline
                label="No"
                type="radio"
                className="fw-bold text-start"
                name="qualitative-evaluation"
                id="no"
                value={false}
                checked={!props.qualOnly}
                onChange={handleChange}
              />
            </Col>
          </Row>
          <Row className="my-1">
            <Col sm={5} className="text-start">
              <label className="fst-italic" htmlFor="quality-weight">
                Qualitative module weight (%):
              </label>
            </Col>
            <Col className="ps-1 d-flex justify-content-start">
              <InputField
                type="number"
                name="qualitativeWeight"
                id="qualitativeWeight"
                fieldtype="number"
              />
            </Col>
          </Row>
          {
            isQuantitativeVisible && <Row className="my-1">
              <Col sm={5} className="text-start">
                <label className="fst-italic" htmlFor="quantitativeWeight">
                  Quantitative module weight (%):
                </label>
              </Col>
              <Col className="ps-1 d-flex justify-content-start">
                <InputField
                    type="number"
                    name="quantitativeWeight"
                    id="quantitativeWeight"
                    fieldtype="number"
                />
              </Col>
            </Row>
          }
        </Block>
    </div>
  );
};
